import { useCallback, useEffect } from 'react';
import { useAppConfig } from '@/context/AppConfigContext';
import { useAutoResize } from '@/hooks/useAutoResize';
import { postToParent, useIframeMessaging } from '@/hooks/useIframeMessaging';
import { fingerprintService } from '@/services/FingerprintService';

export function AppBootstrap(): null {
  const { initFromPayload } = useAppConfig();

  const handleInit = useCallback(
    (payload: Parameters<typeof initFromPayload>[0]) => {
      initFromPayload(payload);
    },
    [initFromPayload],
  );

  useIframeMessaging(handleInit);
  useAutoResize();

  useEffect(() => {
    postToParent({ type: 'READY' });
    void fingerprintService.init();
  }, []);

  return null;
}
